import React from "react";
import { View, Text, StyleSheet } from "@react-pdf/renderer";
import ClientReportsSubtasks from "./ClientReportsSubtasks";

const styles = StyleSheet.create({
  tableContainer: {
    flexDirection: "row",
    flexWrap: "wrap",
    marginTop: 50,
  },
  rows: {
    flexDirection: "row",
    borderBottomColor: "#bff0fd",
    borderBottomWidth: 1,
    alignItems: "center",
    fontStyle: "bold"
  },
  dates: {
    width: "10%",
    textAlign: "left",
    paddingRight: 4,
    paddingLeft: 4,
    paddingTop: 4,
  },
  tasks: {
    width: "25%",
    textAlign: "left",
    paddingRight: 10,
    paddingLeft: 8,
    paddingTop: 4,
  },
  subclients: {
    width: "15%",
    textAlign: "left",
    paddingRight: 2,
    paddingLeft: 10,
    paddingTop: 4,
  },
  details: {
    width: "50%",
    textAlign: "left",
    paddingRight: 8,
  },
});

const ClientReportsTask = ({ taskData }) => 
{
   const reportTasks = taskData.map((t) => (
    <React.Fragment>
      <View style={styles.rows} key={t.task} wrap={false}>
        <Text style={styles.dates}>{t.startdate}</Text>
        <Text style={styles.tasks}>{t.task}</Text>
        <Text style={styles.subclients}>{t.subclient}</Text>
        <View style={styles.details}>
          <View>
            <ClientReportsSubtasks subtaskRow = {t.subtask} timeTot = {t.time} />
          </View>  
        </View>
      </View>
    </React.Fragment>
   ));

  return( 
    <React.Fragment>
      {reportTasks}
    </React.Fragment>
  )
};

export default ClientReportsTask;
